import type { ImageLoaderProps } from 'next/image'

/**
 * Custom image loader for Payload CMS images
 * Uses /api/media route for Payload images, _next/image for static assets
 */
export const payloadImageLoader = ({ src, width, quality }: ImageLoaderProps): string => {
  // If it's a Payload media URL, use it directly with optimization params
  if (src.includes('/api/media')) {
    const separator = src.includes('?') ? '&' : '?'
    return `${src}${separator}width=${width}&quality=${quality || 75}`
  }

  // For static assets, use Next.js image optimization
  const params = new URLSearchParams({
    url: src,
    w: width.toString(),
    q: (quality || 75).toString(),
  })

  return `/_next/image?${params.toString()}`
}
